export interface GridInterface {
  contentMaxWidth: {
    wide: number
    desktop: number
    mobile: number
  }
  gap: {
    mobile: number
    desktop: number
  }
}

export const grid = {
  contentMaxWidth: {
    wide: 1160,
    desktop: 768,
    mobile: 400,
  },
  gap: {
    mobile: 10,
    desktop: 40,
  },
}



// WEBPACK FOOTER //
// ./src/utils/theme/grid.ts